import * as React from "react";
import * as ReactDOM from "react-dom";
import { AppContextProvider } from "./Map/AppContext";
import { IMammadabaMapProps, MammadabaMap } from "./Map/mapProvider";

/**
 * Renders map on container. This method must be called every time you change Map props, with the same container node
 * @param props Map props
 * @param container HTML div node
 */
export const renderMap = (props: IMammadabaMapProps, container: HTMLDivElement): void => {
    ReactDOM.render(
        <AppContextProvider>
            <MammadabaMap {...props} />
        </AppContextProvider>,
        container
    );
};
